import React from 'react';
import { useNavigate } from 'react-router-dom';
import NavBar from "../Components/NavBar.jsx"
import Carousel from '../Components/Carousel.jsx';
import { IEEE_LOGO, IEEE_DP_LOGO, LOGO_SRC} from '../Constants.js';



function Home(){
    let navigate = useNavigate()
    return(
        <>
            <NavBar></NavBar>
            <section class = "intro-section " style = {{backgroundImage : `url(${LOGO_SRC})`}}>


            </section>
                            <h2 style =  {{display : "flex", justifyContent : "center"}}>
                <a href = "https://cmt3.research.microsoft.com/CINS2025">
                    <button>
                    <p className="roboto-condensed-300">Paper Submission</p>
                    </button>

                </a>
            </h2>


            <section className = "home-section main-body">
                <section className = "main-body-para">
                    <h2 className = "roboto-condensed-700">About CINS</h2>
                    <p className = "roboto-300">The international conference on Computational Intelligence and Network Systems (CINS)  is the flagship conference of the Department of Computer Science, Birla Institute of Technology and Science Pilani, Dubai Campus. CINS  is the 3rd edition of the series and it provides opportunities to academicians, researchers, industry practitioners to discuss the contemporary challenges within computing systems and the utilization of intelligent approaches to improve computing methodologies. </p>
                </section>
                <section className = "main-body-para">
                    <h2 className = "roboto-condensed-700">About BITS Pilani Dubai Campus</h2>
                    <p className = "roboto-300">BITS Pilani, Dubai Campus is the international branch of the renowned Birla Institute of Technology and Science, Pilani (BITS Pilani), India. Located in Dubai International Academic City, it is one of the largest engineering institutions in the region and has been awarded a 5-star rating by KHDA. Dedicated exclusively to engineering and technology education, the campus offers B.E., M.E., MBA, and Ph.D. programs across various disciplines. It attracts around 1500 students from over 20 countries, providing a vibrant and diverse academic environment. The Dubai Campus combines world-class infrastructure with strong academic rigor, promoting innovation, research, and entrepreneurship. It benefits from BITS Pilani's legacy of excellence and its strong global alumni network. The campus plays a crucial role in extending the institute's vision of delivering high-quality technical education beyond India.</p>
                </section>
                <section className = "main-body-para">
                    <h2 className = "roboto-condensed-700">About Computer Science Department</h2>
                    <p className = "roboto-300">The Computer Science Department at BPDC has been operational since the campus’s inception in 2000. It offers B.E. in Computer Science, M.E. in Software Systems, and Ph.D. programs, along with a Minor in Data Science to meet industry demands. With a vibrant student body of 800 and experienced faculty from academia and industry, the department is committed to academic and research excellence.</p>
                </section>
                    
            </section>
            <section className = "home-section important-dates">
                <h2 className = "roboto-condensed-700">Important Dates</h2>
                <div class = "important-dates-items">
                    <div class = "important-dates-item">
                        <p style = {{display : "flex"}}>
                            <p class = "event-date roboto-condensed-700" style = {{textDecoration : "line-through"}} >31<sup>st</sup> JUL 2025</p>
                            <p class = "event-date roboto-condensed-700" style = {{textDecoration : "line-through"}}  >21<sup>st</sup> AUG 2025</p>
                            <p class = "event-date roboto-condensed-700" >10<sup>th</sup> SEP 2025</p>
                        </p>
                        <p class = "event-name roboto-condensed-300">Final Extended Paper Submission Deadline</p>
                    </div>
                    <div class = "important-dates-item">
                        <p style = {{display : "flex"}}>
                            <p class = "event-date roboto-condensed-700" style = {{textDecoration : "line-through"}}>30<sup>th</sup> SEP 2025 </p>
                            <p class = "event-date roboto-condensed-700">5<sup>th</sup> OCT 2025 </p>
                        </p>
                        <p class = "event-name roboto-condensed-300">Acceptance Notification</p>
                    </div>
                    <div class = "important-dates-item">
                        <p class = "event-date roboto-condensed-700">15<sup>th</sup> OCT 2025</p>
                        <p class = "event-name roboto-condensed-300">Early Bird Registration Deadline <br></br>
                        Camera Ready Paper Deadline</p>
                    </div>
                    <div class = "important-dates-item">
                        <p class = "event-date roboto-condensed-700">30<sup>th</sup> OCT 2025 </p>
                        <p class = "event-name roboto-condensed-300">Registration Deadline </p>
                    </div>
                </div>
            </section>
            
            <section className = "home-section sponsor">
                 <h2 className = "roboto-condensed-700">Sponsor</h2>

                <div class="sponsor-items">
                    <img src = {IEEE_LOGO}></img>
                    <img src = {IEEE_DP_LOGO}></img>

                </div>
            </section>
        </>
    )



}


export default Home